import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    balance: 0,
    money: 0,
    language:  window.localStorage.getItem('lhkdLang') || 'en',
  },
  mutations: {
    // LTL余额
    UPDATE_BALANCE(state, amount) {
      state.balance = amount;
    },

    // 打单余额
    UPDATE_MONEY(state, amount) {
      state.money = amount;
    },
    // 修改语言
    SET_LANGUAGE: (state, language) => {
      state.language = language
      window.localStorage.setItem('lhkdLang',language)
      window.location.reload()
    },
  },
  actions: {
    updateBalance({ commit }, amount) {
      // 这里可以执行异步操作，例如 API 调用
      // 然后提交 mutation
      commit('UPDATE_BALANCE', amount);
    },
    updateMoney({ commit }, amount) {
      // 这里可以执行异步操作，例如 API 调用
      // 然后提交 mutation
      commit('UPDATE_MONEY', amount);
    },
    updateLang({ commit }, amount) {
      // 这里可以执行异步操作，例如 API 调用
      // 然后提交 mutation
      commit('SET_LANGUAGE', amount);
    },
  }
});